import {
  ChatMessage,
  MessageType,
} from 'app/my-appointments/components/interfaces';
import { groupChatMessages } from 'app/my-appointments/components/modalContent/VideoRoom';
import { AppointmentChatMessage } from 'graphql/generated/remote-schema-hasura';
import { useCallback, useState } from 'react';
import { Roles } from '../firebase/interfaces';
import { encodeMediaInChat } from '../utilities/functions';
import { v4 as uuid } from 'uuid';
import { mapApiFileTypeToFileType } from '../utilities/fileHelpers';

const getSenderType = (from: string): Roles | null => {
  switch (from.toLowerCase()) {
    case Roles.PATIENT:
      return Roles.PATIENT;
    case Roles.PROVIDER:
      return Roles.PROVIDER;
    default:
      return null;
  }
};

function useParseChatMessages(): [
  (messages: AppointmentChatMessage[]) => ChatMessage[] | undefined,
  boolean,
] {
  const [chatMediaLoading, setChatMediaLoading] = useState<boolean>(false);
  const parseMessages = useCallback((messages: AppointmentChatMessage[]) => {
    setChatMediaLoading(true);
    try {
      const messagesParsed = messages.map<ChatMessage>((message) => {
        if (message.mediaUrl) {
          return {
            id: '',
            senderType: getSenderType(message.from) as Roles,
            mediaURL: message.mediaUrl,
            message: encodeMediaInChat(
              message.fileId ?? uuid(),
              message.mediaUrl,
              mapApiFileTypeToFileType[message.contentType as string],
              message.fileName || undefined,
              message.size,
            ),
            type: MessageType.MEDIA,
          };
        }
        return {
          senderType: getSenderType(message.from) as Roles,
          message: message.message as string,
          id: '',
        };
      });

      return groupChatMessages(messagesParsed);
    } catch (error) {
      console.error(error);
    } finally {
      setChatMediaLoading(false);
    }
  }, []);
  return [parseMessages, chatMediaLoading];
}

export default useParseChatMessages;
